import type { AxiosInstance } from 'axios';
import authService from './auth.service';
import type { ClientSummary } from './manager.service';

class AgentService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  /** Active clients where `agentId` is the assigned agent. Agents
   *  pass their own UUID (resolved from /auth/me cache);
   *  managers/super_admin can target any agent. Backend handles RBAC. */
  async listClientsForAgent(agentId: string): Promise<ClientSummary[]> {
    const res = await this.api.get<{ items: ClientSummary[] }>(
      `/api/v1/agents/${agentId}/clients`,
    );
    return res.data.items;
  }

  /** Shortcut: agent's own roster. Internally resolves the caller's
   *  UUID via /auth/me (cached). */
  async listMyClients(): Promise<ClientSummary[]> {
    const id = await authService.getMyId();
    return this.listClientsForAgent(id);
  }
}

export default new AgentService();
